import React, { useEffect, useState } from "react";
import {
  Container, Typography, Box, CircularProgress, Card, CardContent, Divider, Chip
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const UserPanel = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const load = () => {
    setLoading(true);
    fetch("/sistema/get-user-info/", {
      method: "GET",
      credentials: "include",
      headers: { "Cache-Control": "no-store" }
    })
      .then(async (res) => {
        if (res.status === 401) {
          setLoading(false);
          navigate("/login", { replace: true });
          return;
        }
        const data = await res.json();
        if (data?.error) setError(data.error);
        else setUserInfo(data);
        setLoading(false);
      })
      .catch(() => {
        setError("No se pudo obtener la información del usuario.");
        setLoading(false);
      });
  };

  useEffect(() => {
    document.title = "Hydro Luz | Mi Cuenta";
    window.scrollTo(0, 0);
    load();

    const onPageShow = (e) => {
      if (e.persisted) load();        
    };
    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, [navigate]);

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom align="center" sx={{ color: "#004aad" }}>
        Mi Cuenta
      </Typography>

      {loading ? (
        <Box display="flex" justifyContent="center" mt={4}><CircularProgress /></Box>
      ) : error ? (
        <Typography color="error" align="center">{error}</Typography>
      ) : userInfo && (
        <Card elevation={4} sx={{ borderRadius: 3, mt: 3 }}>
          <CardContent>
            <Box textAlign="center" mb={2}>
              <Chip
                label={`⭐ ${userInfo.puntos} Puntos`}
                sx={{ fontSize: "1rem", fontWeight: "bold", bgcolor: "#FFD700", color: "#000", px: 2, py: 1 }}
              />
              <Typography variant="body2" sx={{ mt: 1, color: "text.secondary" }}>
                ¡Tus compras suman puntos que podrás canjear más adelante!
              </Typography>
            </Box>
            <Divider sx={{ my: 2 }} />
            <Typography variant="body1" gutterBottom><strong>Nombre:</strong> {userInfo.nombre}</Typography>
            <Typography variant="body1" gutterBottom><strong>Teléfono:</strong> {userInfo.telefono}</Typography>
            <Typography variant="body1" gutterBottom><strong>Correo:</strong> {userInfo.email}</Typography>
          </CardContent>
        </Card>
      )}
    </Container>
  );
};

export default UserPanel;
